import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiCreateRisk, type CreateRiskInput } from '../api/risks.api';
// import type { Risk } from '../types/risk.type';

export function useCreateRisk(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (input: CreateRiskInput) => apiCreateRisk(projectId, input),
        onSuccess: async () => {
            await qc.invalidateQueries({ queryKey: ['risks', projectId] });
            await qc.invalidateQueries({ queryKey: ['riksCategories', projectId] });
        },
    });
}
